import Api from "./api";

class CompagnyService extends Api {}

export default new CompagnyService({
  ressource: "/admin/companies"
});
